
import { useState } from "react"
import { CaretDownFill, CaretUpFill } from 'react-bootstrap-icons'
import MarketSingleTable from "./MarketSingleTable"


function MarketSortableTable(props) {
    const [sortBy, setSortBy] = useState(null)
    const [sortOrder, setSortOrder] = useState('asc')
    const { config, rows } = props;

    const handleSortChange = async (accessor) => {
        if (sortOrder === 'asc') {
            setSortOrder('desc');
            setSortBy(accessor);
        } else if (sortOrder === 'desc') {
            setSortOrder('asc');
            setSortBy(accessor);
        }
    }

    const updatedConfig = config.map((column) => {
        if (!column.sortValue) {
            return column;
        }

        return {
            ...column,
            header: () => (
                <th
                    className="cursor-pointer text-center"
                    onClick={() => handleSortChange(column.key)}
                >
                    {column.value}
                    {getIcons(column.key, sortBy, sortOrder)}
                </th>
            ),
        };
    });


    let sortedData = rows;
    if (sortOrder && sortBy) {
        const { sortValue } = config.find((column) => column.key === sortBy);
        sortedData = [...rows].sort((a, b) => {
            const valueA = sortValue(a);
            const valueB = sortValue(b);

            const reverseOrder = sortOrder === 'asc' ? 1 : -1;

            if (typeof valueA === 'string') {
                return valueA.localeCompare(valueB) * reverseOrder;
            } else {
                return (valueA - valueB) * reverseOrder;
            }
        });
    }


    return rows.length > 0 ? <MarketSingleTable {...props} config={updatedConfig} rows={sortedData} /> : <div className="alert alert-warning">موردی یافت نشد</div>
    // return <MarketTable onSort={handleSortChange} onFilter={handleFilter} isFilter={isFilter} config={config} rows={stockList} filterBy={filterBy} single date={date} />
}

function getIcons(key, sortBy, sortOrder) {
    if (key !== sortBy) {
        return (
            <span className="sortIcon">
                <CaretUpFill />
                <CaretDownFill />
            </span>
        );
    }

    if (sortOrder === null) {
        return (
            <span className="sortIcon">
                <CaretUpFill />
                <CaretDownFill />
            </span>
        );
    } else if (sortOrder === 'asc') {
        return (
            <span className="sortIcon">
                <CaretUpFill />
            </span>
        );
    } else if (sortOrder === 'desc') {
        return (
            <span className="sortIcon">
                <CaretDownFill />
            </span>
        );
    }
}

export default MarketSortableTable